import React from 'react';
import { HelpContacts } from 'components';

function HelpPageComponent() {
    return <HelpContacts />;
}

export default HelpPageComponent;
